import { SVG, SVGProps } from './svg'

export function IconChartBubble(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <circle cx="5.5" cy="12.5" r="3.5" />
      <circle cx="16.5" cy="12.5" r="5.5" />
    </SVG>
  )
}
